export const DEPT_OPTION = [
  // { value: '', label: 'Bỏ chọn' },
  { value: 'NCC_THUCTE', label: 'CN NCC thực tế' },
  { value: 'NCC_NGAYPHATHANGTHUCTE', label: 'CN NCC theo ngày phát hàng thực tế' },
  { value: 'NCC_NGAYDATHANGTHUCTE', label: 'CN NCC theo ngày đặt hàng thực tế' },
  { value: 'NCCVC', label: 'Công nợ vận chuyển' },
  { value: 'NCCTIENTE', label: 'Công nợ thanh toán' },
  { value: 'NCCTHUE', label: 'Công nợ thuế' },
  
]


export const balanceOfdebtType = {
  NCC_THUCTE: "NCC_THUCTE",
  NCC_NGAYPHATHANGTHUCTE: "NCC_NGAYPHATHANGTHUCTE",
  NCC_NGAYDATHANGTHUCTE: "NCC_NGAYDATHANGTHUCTE",
  NCCVC: "NCCVC",
  NCCTIENTE: "NCCTIENTE",
  NCCTHUE: "NCCTHUE",
}

export const slug = {
  NCC_THUCTE: "congno-ncc-thucte",
  NCC_NGAYPHATHANGTHUCTE: "congno-ncc-phathang",
  NCC_NGAYDATHANGTHUCTE: "congno-ncc-dathang",
  NCCVC: "congno-ncc-vanchuyen",
  NCCTIENTE: "congno-ncc-tiente",
  NCCTHUE: "congno-ncc-thue",
}

export const convertSlugToType = (loaiDoiTuong: string) => {
  switch (loaiDoiTuong) {
    case slug.NCC_THUCTE:
      return balanceOfdebtType.NCC_THUCTE
    case slug.NCC_NGAYPHATHANGTHUCTE:
      return balanceOfdebtType.NCC_NGAYPHATHANGTHUCTE
    case slug.NCC_NGAYDATHANGTHUCTE:
      return balanceOfdebtType.NCC_NGAYDATHANGTHUCTE
    case slug.NCCVC:
      return balanceOfdebtType.NCCVC
    case slug.NCCTIENTE:
      return balanceOfdebtType.NCCTIENTE
      case slug.NCCTHUE:
        return balanceOfdebtType.NCCTHUE
    default:
      return ""
  }
}
export const convertTypeToSlug = (loaiDoiTuong: string) => {
  switch (loaiDoiTuong) {
    case balanceOfdebtType.NCC_THUCTE:
      return slug.NCC_THUCTE
    case balanceOfdebtType.NCC_NGAYPHATHANGTHUCTE:
      return slug.NCC_NGAYPHATHANGTHUCTE
    case balanceOfdebtType.NCC_NGAYDATHANGTHUCTE:
      return slug.NCC_NGAYDATHANGTHUCTE
    case balanceOfdebtType.NCCVC:
      return slug.NCCVC
    case balanceOfdebtType.NCCTIENTE:
      return slug.NCCTIENTE
      case balanceOfdebtType.NCCTHUE:
        return slug.NCCTHUE
    default:
      return ""
  }
}




